<div class="file-upload">
    <!-- Drag&Drop -->
    <div
        *ngIf="!files?.length"
        class="drag-drop-container"
        ImgDragDrop
        (fileDropped)="onFileDropped($event)"
        (click)="openFileUploadWindow(fileUpload)"
    >
        <p [innerHTML]="htmlContent" class="text-center mb-3 mb-sm-5"></p>
        <input
            type="file"
            class="d-none"
            (change)="fileBrowseHandler($event)"
            #fileUpload
            multiple
            accept="image/png, image/bmp, image/jpeg, image/jpg, image/webp, image/gif"
            (click)="$event.target.value = null"
        />
        <app-ss-button
            [class]="'btn btn-continue'"
            (click)="openFileUploadWindow(fileUpload)"
            [text]="'app.global.modals.image_manager.upload_image_modal.computer.upload_file' | translate"
        >
        </app-ss-button>
    </div>
    <!-- Drag&Drop -->

    <!-- Imgs -->
    <div
        *ngIf="files?.length"
        class="container-box d-flex flex-wrap justify-content-center justify-content-lg-start overflow-auto"
    >
        <input
            type="file"
            class="d-none"
            (change)="fileBrowseHandler($event)"
            #fileUpload
            multiple
            accept="image/png, image/bmp, image/jpeg, image/jpg, image/webp, image/gif"
            (click)="$event.target.value = null"
        />
        <ng-container *ngFor="let file of files; let i = index">
            <div
                class="img-container position-relative mr-3 mb-3"
                (click)="toggleFileSelection(file)"
                [ngClass]="{ 'no-image-action': selectedFiles.size === 15 }"
            >
                <input type="checkbox" [checked]="selectedFiles.has(file)" />
                <img class="w-100 preview-img" [src]="file.url" alt="File preview" />
                <div class="buttons-container d-flex flex-wrap justify-content-end">
                    <i class="fa-light fa-trash delete-btn" (click)="deleteFile(i); $event.stopPropagation()"></i>
                    <i
                        class="fa-light fa-magnifying-glass carousel-btn"
                        (click)="openCarouselModal(i); $event.stopPropagation()"
                    ></i>
                </div>
            </div>
        </ng-container>
        <div
            class="img-container borde position-relative mr-3 mb-3 d-flex justify-content-center align-items-center"
            (click)="openFileUploadWindow(fileUpload)"
        >
            <i class="fa-light fa-upload"></i>
            <p class="mb-0 mt-2">
                {{ 'app.global.modals.image_manager.upload_image_modal.computer.buttons.add_image' | translate }}
            </p>
        </div>
    </div>
    <!-- Imgs -->

    <div
        *ngIf="files?.length"
        class="d-flex justify-content-between justify-content-sm-end mt-3 mt-lg-4 mb-3"
        [ngClass]="!(isMobile$ | async) ? 'modal-buttons' : ''"
    >
        <button class="btn btn-skip mr-3" tabindex="0" (click)="reset()">
            {{ 'app.global.modals.image_manager.upload_image_modal.computer.buttons.cancel' | translate }}
        </button>
        <button
            class="btn btn-continue"
            type="submit"
            tabindex="0"
            (click)="upload()"
            [disabled]="!selectedFiles.size || loading"
        >
            {{ 'app.global.modals.image_manager.upload_image_modal.computer.buttons.add_image' | translate }}
        </button>
    </div>
</div>
<mc-loading [overlay]="true" *ngIf="loading" size="lg"></mc-loading>
